import React, { useState, useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import WebHookInfo from '../../components/WebHookInfo';
import useApi from '../../api/useApi';
import Notification from '../../components/Notification';
import '../../scrollbar.css';

function WebHooks() {
  // const location = useLocation();
  const [openCreate, setOpenCreate] = useState(false);
  const [selectedWebhook, selectWebhook] = useState({ id: '', name: '' });
  const [{ isLoading, isError, data }, getData] = useApi();
  const [webhook, setWebhook] = useState([]);
  const [onClose, setOnClose] = useState(false);
  const [state, deleteWebhook] = useApi();
  const [action, setAction] = useState('');
  const [notification, setNotification] = useState(false);
  const [type, setType] = useState(null);
  const [message, setMessage] = useState(null);
  const [formData, setFormData] = useState({ q: '', status: '' });
  const [filteredData, setFilteredData] = useState([]);
  const handleInputChange = useCallback((e) => setFormData({ ...formData, [e.target.name]: e.target.value }));
  const user = localStorage.getItem('user');
  if (!user) {
    location.href = '/';
  }
  const orgId = user && JSON.parse(localStorage.user).organization.id;

  useEffect(() => {
    user && getData(`/organization/${orgId}/webhooks`, 'GET');
  }, []);

  useEffect(() => {
    if (!isLoading && !isError && data) {
      setWebhook(data.webhook);
      setFilteredData(data.webhook);
    }

    if (isError) {
      setType('error');
      setMessage('Unable to fetch Webhook');
      setNotification(!notification);
    }
  }, [isLoading, isError, data]);

  const toggleOpenCreate = () => {
    setOpenCreate((prev) => !prev);
  };

  const handleDelete = () => {
    deleteWebhook(`/webhook/${selectedWebhook.id}`, 'DELETE');
  };

  const createNotification = (types, messages) => {
    setType(types);
    setMessage(messages);
    setNotification(!notification);
  };

  useEffect(() => {
    if (state.data) {
      getData(`/organization/${orgId}/webhooks`, 'GET');
      setType('delete');
      setOnClose(false);
      setMessage('Delete webhook detail successfully');
      setNotification(!notification);
    }
    if (state.isError) {
      setType('error');
      setMessage('Unable to delete webhook');
      setNotification(!notification);
    }
  }, [state]);

  useEffect(() => {
    if (filteredData.length <= 0) {
      return;
    }
    let z = filteredData;
    if (formData.q === '' && formData.status === '') {
      setWebhook(filteredData);
    }
    if (formData.q) {
      z = z.filter((x) => {
        const normalizedQuery = formData.q.toLowerCase();
        return (
          x?.url?.toLowerCase().indexOf(normalizedQuery) >= 0 ||
          x?.eventType?.toLowerCase().indexOf(normalizedQuery) >= 0
        );
      });
    }

    if (formData.status) {
      z = z.filter((x) => x?.isActive.toString() === formData.status);
    }

    if (z.length > 0) setWebhook(z);
    else setWebhook([]);
  }, [formData]);

  const refreshList = () => {
    getData(`/organization/${orgId}/webhooks`, 'GET');
    // toggleOpenCreate();
  };

  const alertMsg = (msg) => {
    setNotification(msg);
  };

  return (
    <>
      {notification && <Notification type={type} message={message} alertMsg={alertMsg} />}
      {onClose && (
        <div
          className="flex justify-center items-center h-full w-full fixed z-20 px-16"
          style={{ background: 'linear-gradient(rgba(0, 0, 0, 0.5),   rgba(0, 0, 0, 0.5))' }}
        >
          <div className="bg-white px-16 text-xl block m-auto rounded-2xl">
            <span className="block text-center mt-10 mb-8">Do you want to delete webhook {selectedWebhook.name}?</span>
            <div className="flex justify-center items-center mb-10 font-bold">
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-10 py-4 rounded-lg text-sm mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={handleDelete}
              >
                YES
              </button>
              <button
                type="submit"
                className="mt-1 lg:mt-0 w-full lg:w-max border px-10 py-4 rounded-lg text-sm mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setOnClose(false);
                }}
              >
                NO
              </button>
            </div>
          </div>
        </div>
      )}
      {openCreate && (
        <WebHookInfo
          handleClose={toggleOpenCreate}
          action={action}
          notification={createNotification}
          selectedWebhook={selectedWebhook.id}
          refreshList={() => refreshList()}
        />
      )}

      <div
        className="h-full w-topBar fixed hideScroll"
        style={{ filter: openCreate && 'blur(2px)', left: '12%', width: '88%', overflow: 'auto' }}
      >
        <div className="z-50" style={{ height: '22vh', background: '#f9f9f9', paddingBottom: '4vh' }}>
          <div
            className="lg:flex block sm:block justify-between text-center lg:text-left w-tableWidth m-auto "
            style={{ paddingTop: '4vh' }}
          >
            <span className="text-textBlue1 font-bold text-xl">Webhooks</span>

            <div className="block lg:flex mt-1 lg:mt-0">
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('create');
                  toggleOpenCreate();
                }}
              >
                <img src="assets/img/Create.svg" className="h-3 mr-2 " alt="" />
                CREATE
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  setAction('update');
                  if (selectedWebhook.id) toggleOpenCreate();
                }}
              >
                <img src="assets/img/Edit.svg" className="h-3 mr-2 " alt="" />
                EDIT
              </button>
              <button
                className="mt-1 lg:mt-0 w-full lg:w-max border px-3 py-1 rounded-sm text-xs mx-3 font-bold focus:outline-none flex justify-center items-center h-7 bg-btnBg text-white"
                onClick={() => {
                  if (selectedWebhook.id) setOnClose(true);
                }}
              >
                <img src="assets/img/Delete.svg" className="h-3 mr-2 " alt="" />
                DELETE
              </button>
              <div className="mt-1 lg:mt-0 w-full lg:w-max border bg-transparent px-4 rounded-sm ml-3 flex justify-between items-center rounded-md">
                <input
                  type="text"
                  placeholder="Search Webhook"
                  autoComplete="off"
                  className="text-textBox bg-transparent focus:outline-none"
                  value={formData.q}
                  name="q"
                  onChange={handleInputChange}
                  style={{ borderColor: '#e6e6e6' }}
                />
                <img src="assets/img/Search.png" className="h-4 ml-2 " alt="" />
              </div>
            </div>
          </div>
        </div>

        <div className="tbl" style={{ minWidth: '700px' }}>
          <div className="bg-tableBg w-tableWidth m-auto mb-3">
            <div className="bg-tableHeader w-full flex border" style={{ borderColor: '#e6e6e6' }}>
              <div className="px-6 flex w-full relative">
                <div className=" py-4 px-4 text-sm font-bold w-full">URL</div>
                <div className=" py-4 text-sm font-bold w-2/6">EVENT</div>
                <div className=" py-2 text-sm font-bold w-1/6">
                  <div className="relative inline-flex">
                    <svg
                      className="w-3 h-2 absolute top-0 right-0 m-4 sm:mt-4 sm:mx-2 sm:mb-4 lg:m-4 pointer-events-none"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 412 232"
                    >
                      <path
                        d="M206 171.144L42.678 7.822c-9.763-9.763-25.592-9.763-35.355 0-9.763 9.764-9.763 25.592 0 35.355l181 181c4.88 4.882 11.279 7.323 17.677 7.323s12.796-2.441 17.678-7.322l181-181c9.763-9.764 9.763-25.592 0-35.355-9.763-9.763-25.592-9.763-35.355 0L206 171.144z"
                        fill="#648299"
                        fillRule="nonzero"
                      />
                    </svg>
                    <select
                      value={formData.status}
                      name="status"
                      className="border-2 font-bold overflow-ellipsis overflow-hidden whitespace-nowrap h-10 pl-0 lg:pl-3 pr-5 lg:pr-10 bg-transparent hover:border-gray-400 focus:outline-none appearance-none rounded-xl"
                      onChange={handleInputChange}
                      style={{ borderColor: '#e6e6e6' }}
                    >
                      <option value="">STATUS</option>
                      <option value="true">ACTIVE</option>
                      <option value="false">INACTIVE</option>
                    </select>
                  </div>
                </div>
                {/* <div className=" py-4 px-4 text-sm font-bold w-1/6">STATUS</div> */}
                {/* <img src="assets/img/Filter.svg" className="w-5 absolute top-5 right-3" /> */}
              </div>
            </div>
            {!isLoading ? (
              <div
                className="pb-1 border hideScroll"
                style={{ borderColor: '#e6e6e6', height: '77vh', overflow: 'auto' }}
              >
                {webhook.map((item) => (
                  <div
                    className="m-2.5 px-4 bg-white flex rounded-md
                    shadow-sm relative border-2 border-transparent hover:border-indigo-200 focus-within:border-indigo-200"
                  >
                    <input
                      type="checkbox"
                      className="absolute left-3 top-5"
                      checked={selectedWebhook.id === item.id}
                      onClick={() => {
                        if (selectedWebhook.id !== item?.id) {
                          selectWebhook({ id: item.id, name: item.eventType });
                        } else {
                          selectWebhook({ id: '', name: '' });
                        }
                      }}
                      // onChange={() => selectWebhook(item.id)}
                    />

                    <div className="text-role py-4 px-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm px-2 w-full">
                      {item?.url}
                    </div>
                    <div className="text-role py-4 px-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm px-2 w-2/6">
                      {item?.eventType}
                    </div>
                    <div className="text-role py-4 px-4 overflow-ellipsis overflow-hidden whitespace-nowrap text-sm px-2 w-1/6">
                      {item?.isActive ? 'ACTIVE' : 'INACTIVE'}
                    </div>
                  </div>
                ))}
              </div>
            ) : (
              <img src="assets/img/loader.svg" className="w-18 mx-auto my-16" alt="" />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default WebHooks;
